module.exports = __webpack_public_path__ + "static/logos/snow-forecast__logo-2b21a8eac49688d6b69d907c6fc62981.svg";